import { defineStore } from 'pinia';
import makesAPI from '@/api/makes';

export const useMakeStore = defineStore('makes', {
    state: () => ({
        makes: [] as any[],
    }),
    actions: {
        async fetchMakes(filters: Record<string, any>) {
            try {
                const response = await makesAPI.getMakes(filters);
                this.makes = response.data.data;
            } catch (error) {
                console.error('Error fetching car listings:', error);
            }
        },
    }
});